import React from "react";

const Quote = ({
  className,
  fill = "#BCD0E0",
  styles
}: {
  className: string;
  fill?: string;
  styles?: React.CSSProperties;
}) => {
  return (
    <svg
      style={styles}
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99185 12.9385C10.3965 12.7847 11.0281 12.4468 11.4851 12.1396C12.0318 11.7721 12.7831 11.0711 13.1572 10.5793C13.8291 9.69608 14.1807 8.79773 14.3827 7.44737C14.5185 6.53933 14.5282 6.30879 14.5407 3.67319C14.554 0.870161 14.5662 1.0461 14.3441 0.82402C14.1298 0.609683 14.2565 0.619316 11.6461 0.619316C9.12489 0.619316 9.21315 0.614172 9.00486 0.773064C8.95166 0.813622 8.87489 0.903385 8.83423 0.972514L8.76034 1.09824L8.75292 3.48641L8.74547 5.87459L8.80462 6.01205C8.87405 6.17344 9.0646 6.35329 9.20852 6.39327C9.26753 6.40964 9.7592 6.42086 10.4229 6.42094L11.5381 6.42111L11.5381 6.59319C11.5381 6.985 11.4264 7.64994 11.2865 8.09049C11.1006 8.6762 10.817 9.14844 10.4061 9.55629C10.0709 9.88905 9.68268 10.1533 9.13701 10.4203C8.738 10.6155 8.67815 10.6639 8.56852 10.8804C8.53948 10.9378 8.52014 11.04 8.51918 11.141C8.51781 11.2872 8.53604 11.3466 8.67082 11.6351C9.18373 12.7328 9.22568 12.8024 9.43994 12.9117C9.59705 12.9919 9.82266 13.0028 9.99185 12.9385ZM1.89911 12.9586C2.05078 12.9306 2.76394 12.5816 3.15011 12.3464C4.32169 11.6329 5.23621 10.6769 5.77137 9.60643C6.16269 8.82365 6.35653 8.03291 6.49304 6.66221C6.52933 6.29796 6.53973 5.75333 6.54952 3.70078C6.56307 0.866987 6.57533 1.04643 6.35292 0.82402C6.13861 0.609709 6.26524 0.619315 3.6564 0.619315C1.11355 0.619315 1.20268 0.613786 0.995895 0.784228C0.941654 0.828945 0.865383 0.929546 0.826386 1.00779L0.755505 1.15004L0.756106 3.51873C0.756708 5.84257 0.757776 5.88978 0.812456 6.0106C0.876522 6.15217 0.974249 6.26243 1.11127 6.34776C1.20484 6.40605 1.23423 6.40775 2.38345 6.42111L3.55985 6.43479L3.5515 6.65373C3.52991 7.21921 3.3934 7.89219 3.20381 8.36761C3.00887 8.85644 2.7754 9.213 2.42111 9.56297C2.09867 9.88146 1.76948 10.1084 1.25273 10.3684C0.757365 10.6176 0.618915 10.7325 0.56284 10.9407C0.496475 11.1871 0.531424 11.3113 0.858049 11.9903C1.04034 12.3692 1.2021 12.6676 1.2645 12.7399C1.42301 12.9237 1.65497 13.0037 1.89911 12.9586Z"
        fill={fill}
      />
    </svg>
  );
};

export default Quote;
